// https://blog.bitsrc.io/component-reusability-techniques-with-angular-727a6c603ad2
// https://2ality.com/2020/01/enum-pattern.html
export abstract class Definitions {
  // token and login
  static readonly acccessTokenSessionKey: string = 'access_Token';

  // user info
  static readonly cidSessionKey: string = 'Cid';
  static readonly lidSessionKey: string = 'Lid';
  static readonly userDataSessionKey: string = 'userData';
  static readonly currPatronSessionKey: string = '_curr_pat';
  static readonly prevPatronSessionKey: string = '_prev_pat';
  static readonly pastLidSessionKey: string = '_past_lid';
  static readonly newLidSessionKey: string = '_newLid';

  // guest
  static readonly isGuestSessionKey: string = 'isGuest';

  //saml
  static readonly cachedRequest4SamlSessionKey: string = '_cachedRequestGuest4Saml';

  //ezproxy
  static readonly cachedRequestEzProxySessionKey: string = '_ez';
  static readonly cachedRequest4rmEzProxySessionKey: string = '_4rm_ez';

  // cms variables
  static readonly activePagesSessionKey: string = 'activePagesArray';
  static readonly inActivePagesSessionKey: string = 'inactivePagesArray';
  static readonly isLibraryExistsSessionKey: string = 'libExists';

  // search
  static readonly searchIdSessionKey: string = '_search_id';
  static readonly didYouMeanSearchRequestSessionKey: string = '_dym_sea';
  static readonly isDidYouMeanSearchSessionKey: string = '_is_dym';
  static readonly searchRequestSessionKey: string = '_sea_req';
  static readonly holdingsSessionKey: string = '_hlds';
  static readonly searchViewSessionKey: string = '_search_view';
  static readonly xfacetFilterSessionKey: string = 'facetFilterArray';
  static readonly zeroResultsPostSessionKey: string = '_zres_pb';
  static readonly didYouMeanSearchTermSessionKey: string = 'did_you_mean_Search-TERM';
  static readonly searchTermSessionKey: string = 'Search-TERM';
  static readonly searchOldestItemAddedKey: string = 'oldest_dtadd_'; // got this one from searchapi `SolrFacetField.OLDEST_ITEM_ADDED`
  static readonly searchHistorySessionKey: string = 'history';

  // your-list
  static readonly requestItemsBatchSessionKey = '_req_items_bat';
  static readonly fullRecordItemsBatchSessionKey = '_fr_items_bat';

  // polices
  static readonly agentInfoSessionKey: string = '_agent_inf';

  // others
  static readonly agControlIdSessionKey: string = 'agctrlid';
  static readonly SEARCHRESULTS_FULLRECORD_AGCONTROLID: string =
    'searchresults_fullrecord_agctrlid';
  static readonly SEARCHRESULTS_YOFFSET: 'searchresults_yoffset';
  static readonly libraryDbPoolSessionKey: string = 'libKey';
  static readonly MARC_REPORT_MAX_NUMBER_OF_TABS = 2;
  static readonly START_RECORD: number = 1;
  static readonly NUM_OF_RECORDS: number = 40;
  static readonly NUM_OF_FACETS_PER_GROUP: number = 20;
  static readonly FACET_OFFSET: number = 0;
  static readonly QUERY_OPTION: string = 'ALL';
  static readonly MATCH_JOIN_OPERATOR: string = 'AND';
  static readonly PAGE_SIZE: number = 40;
  static readonly SEE_MORE_FROM_TARGETS_MAX: number = 8;

  contructor() {}
}
